import { Box } from '@jfs/ui-new'

import { RefreshControl as RefreshControlMobile } from 'react-native'
import { RefreshControl as RefreshControlMobileWeb } from 'react-native-web-refresh-control'
import { TableComponent } from '../../comps/TableComponent'
import { keyExtractorData } from '../../util/billPaymentUtil'
import { isOsMobile } from '../../util/util'
import { TransactionCard } from './TransactionCard'

export const RecentTransactions = ({
  api,
  data,
  onSelect,
  state,
  onLoadMore,
  canFetchMore = false,
  ListEmptyComponent = <></>,
}: any) => {
  // console.log('item.data', data)

  const renderItem = ({ item }) => {
    return <TransactionCard item={item} onSelect={onSelect} />
  }

  const RefreshControl = isOsMobile() ? RefreshControlMobile : RefreshControlMobileWeb
  return (
    <Box pb={10}>
      {/* {state === 'pending' && renderEmpty()} */}
      <TableComponent
        value={''}
        canFetchMore={canFetchMore}
        ListContent={data}
        loadingState={state === 'pending'}
        isCustom={true}
        RenderCustomElement={renderItem}
        keyExtractor={keyExtractorData}
        onListFooterPress={onLoadMore}
        refreshControl={<RefreshControl refreshing={false} onRefresh={api} />}
      //ListEmptyComponent={ListEmptyComponent}
      />
    </Box>
  )
}
